/**
 * Canopy configurator: single/multi select + add to cart
 * Pricing lives in canopy-total-price.js (load that file FIRST)
 */
(function () {
  const SINGLE_STEPS = ['step2', 'step3', 'step4', 'step5a', 'step5b', 'step7'];
  const MULTI_STEP = 'step6';

  const ATC_SELECTORS = [
    '.product-form__submit',
    "form[action='/cart/add'] button[type='submit']",
    "form[action^='/cart/add'] button[type='submit']",
    '#AddToCart',
    '.cd-configurator-add-to-cart',
    '.popup-contect-alert button[type="submit"]',
    '.popup-contect-alert .add-to-cart-btn',
    '.cd-popup-addtocart-button'
  ].join(', ');

  const NOTE_SELECTORS = [
    '#cd-order-note',
    '.cd-popup-content-left .form-item.textarea textarea',
    '.cubmit-from-holder .form-item.textarea textarea',
    '.cd-popup-wrepper textarea'
  ].join(', ');

  function getOrderNote() {
    const el = document.querySelector(NOTE_SELECTORS);
    if (!el) return '';

    let value = (el.value || '').trim();

    // Ignore the default placeholder-style text if user didn't type anything.
    if (value.toLowerCase() === 'note') value = '';

    return value;
  }

  async function updateCartNote(note) {
    if (!note) return;

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note })
    });
  }

  function parsePriceToCents(raw) {
    if (raw == null || raw === '') return 0;
    if (typeof raw === 'number') return raw > 1000 ? Math.round(raw) : Math.round(raw * 100);
    const num = parseFloat(String(raw).replace(/[^0-9.]/g, ''));
    return isNaN(num) ? 0 : Math.round(num * 100);
  }

  function getCheckedAddons() {
    return Array.from(document.querySelectorAll('.addon-checkbox:checked')).map(function (cb) {
      let cents = 0;

      if (cb.dataset.price != null && cb.dataset.price !== '') {
        cents = parsePriceToCents(cb.dataset.price);
      } else {
        const box = cb.closest('.option-box');
        const priceEl = box ? box.querySelector('.cd-addon-option-price') : null;
        if (priceEl) cents = parsePriceToCents(priceEl.textContent);
      }

      return {
        id: cb.dataset.id,
        title: cb.dataset.title || '',
        cents: cents
      };
    });
  }

  function normalizeCartVariantId(id) {
    if (typeof window.resolveVariantId === 'function') {
      const resolved = window.resolveVariantId(id);
      if (resolved) return parseInt(resolved, 10);
    }

    const num = parseInt(String(id).replace(/[^\d]/g, ''), 10);
    return isNaN(num) ? null : num;
  }

  function getMainVariantId() {
    if (typeof window.syncFormVariantFromStep1 === 'function') {
      const synced = window.syncFormVariantFromStep1();
      const normalized = normalizeCartVariantId(synced);
      if (normalized) return normalized;
    }

    if (typeof window.getCurrentVariantId === 'function') {
      const normalized = normalizeCartVariantId(window.getCurrentVariantId());
      if (normalized) return normalized;
    }

    return null;
  }

  function getQuantity() {
    const qtyEl =
      document.querySelector('form[action^="/cart/add"] [name="quantity"]') ||
      document.querySelector('product-form form [name="quantity"]') ||
      document.querySelector('[name="quantity"]');

    if (!qtyEl) return 1;

    const qty = parseInt(qtyEl.value, 10);
    return isNaN(qty) || qty < 1 ? 1 : qty;
  }

  function refreshTotal() {
    if (typeof window.updateTotalUI === 'function') window.updateTotalUI();
  }

  function enforceSingleSelect(stepEl, changedCb) {
    if (!changedCb.checked) return;

    stepEl.querySelectorAll('.addon-checkbox').forEach(function (cb) {
      if (cb !== changedCb) cb.checked = false;
    });
  }

  function bindAddonListeners() {
    SINGLE_STEPS.forEach(function (stepId) {
      const stepEl = document.getElementById(stepId);
      if (!stepEl) return;

      stepEl.addEventListener('change', function (e) {
        const cb = e.target;
        if (!cb.classList.contains('addon-checkbox')) return;

        enforceSingleSelect(stepEl, cb);
        refreshTotal();
      });
    });

    const step6El = document.getElementById(MULTI_STEP);
    if (step6El) {
      step6El.addEventListener('change', function (e) {
        if (!e.target.classList.contains('addon-checkbox')) return;
        refreshTotal();
      });
    }
  }

  function bindStep1VariantSync() {
    const root =
      document.getElementById('step1') ||
      document.querySelector('fieldset.product-form__input');

    if (!root) return;

    root.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="radio"]') || e.target.classList.contains('addon-checkbox')) return;

      if (typeof window.syncFormVariantFromStep1 === 'function') {
        window.syncFormVariantFromStep1();
      }
      refreshTotal();
    });
  }

  async function addVariantToCart(variantId, quantity) {
    const id = normalizeCartVariantId(variantId);

    if (!id) {
      throw new Error('Please select a valid van model (Step 1) before adding to cart.');
    }

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: id, quantity: quantity || 1 }]
      })
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.description || data.message || 'Could not add main product to cart');
    }

    return data;
  }

  async function addAddonsToCart(addons) {
    for (const addon of addons) {
      if (!addon.id) continue;

      const addonId = parseInt(String(addon.id).replace(/[^\d]/g, ''), 10);
      if (!addonId) continue;

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: addonId, quantity: 1 }]
        })
      });

      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.description || data.message || 'Could not add addon to cart');
      }
    }
  }

  async function addConfiguratorToCart() {
    const variantId = getMainVariantId();

    if (!variantId) {
      alert('Please select a van model (Step 1) before adding to cart.');
      return false;
    }

    const addons = getCheckedAddons().filter(function (addon) {
      return addon.id;
    });

    await addVariantToCart(variantId, getQuantity());
    await addAddonsToCart(addons);
    await updateCartNote(getOrderNote());
    window.location.href = '/cart';
    return true;
  }

  function bindAddToCart() {
    document.querySelectorAll(ATC_SELECTORS).forEach(function (btn) {
      if (btn.dataset.configuratorAtcBound === '1') return;
      btn.dataset.configuratorAtcBound = '1';

      btn.addEventListener('click', async function (e) {
        e.preventDefault();
        e.stopPropagation();

        try {
          await addConfiguratorToCart();
        } catch (err) {
          alert(err.message || 'Add to cart failed. Please try again.');
        }
      });
    });
  }

  window.getCheckedAddons = getCheckedAddons;
  window.addConfiguratorToCart = addConfiguratorToCart;

  document.addEventListener('DOMContentLoaded', function () {
    bindAddonListeners();
    bindStep1VariantSync();
    bindAddToCart();
    refreshTotal();
  });
})();
